$(function () {
    if ($("#lscConfiguration").length > 0) {
        applyLang();
        onAge(55);
        updatePY();
        updateDots();
    }
})

const S = {
    lang: 'de',
    insurance: null, age: 55, smoking: null,
    yearsSmoked: 25, cigsPerDay: 12, packYears: 15, lungCancer: null,
};
const stV = { ys: 25, cig: 12 };
let stopped = false, stoppedAt = null;
const TOTAL = 6;

const TX = {
    de: {
        hero_title: 'Übernimmt bei mir die gesetzliche Krankenkasse die Kosten für das Lungenkrebsscreening?',
        hero_sub: 'Beantworten Sie die folgenden Fragen, um dies zu prüfen.',
        back: 'Zurück', confirm: 'Bestätigen',
        badge_ok: '✓ Erfüllt', badge_stop: '✗ Nicht erfüllt', edit_hint: '✎ ändern',
        c1_title: 'Versicherungsart', c2_title: 'Alter',
        c3_title: 'Rauchstatus', c4_title: 'Rauchdauer',
        c5_title: 'Rauchintensität', c6_title: 'Vordiagnose Lungenkrebs',
        c1_sub: 'Welche Art von Krankenversicherung haben Sie?',
        c2_sub: 'Das Screening richtet sich an Personen zwischen 50 und 75 Jahren.',
        c3_sub: 'Wählen Sie die Option, die am besten auf Sie zutrifft.',
        c4_sub: 'Wie viele Jahre haben Sie insgesamt geraucht? (Hinweis: Klicken Sie auf ⓘ für die Berücksichtigung von Rauchpausen.)',
        c5_sub: 'Wie viele Zigaretten rauchen Sie bzw. haben Sie täglich im Durchschnitt geraucht? Hinweis: Klicken Sie auf ⓘ für Erklärungen zu Rauchintensität und Packungsjahren',
        c6_sub: 'Liegt bei Ihnen eine bekannte Lungenkrebserkrankung vor?',
        ins_a: 'Gesetzlich versichert (GKV)', ins_b: 'Privat versichert (PKV)',
        sm_a: 'Ich rauche aktuell',
        sm_b: 'Rauchstopp innerhalb der letzten 10 Jahre',
        sm_c: 'Rauchstopp vor mehr als 10 Jahren',
        sm_d: 'Nie geraucht',
        age_unit: 'Jahre', age_in: '✓ Im Zielbereich (50-75 Jahre)', age_out: '✗ Außerhalb des Zielbereichs',
        ys_unit: 'Jahre', cig_lbl: 'Zigaretten pro Tag:', cig_unit: 'Zigaretten / Tag',
        py_lbl_y: 'Jahre', py_lbl_p: 'PKNG/Tag', py_lbl_r: 'Packungsjahre',
        py_hint: 'z.B. 25 Jahre x 0,6 PKNG/Tag = 15 Packungsjahre',
        py_ok: '✓ Mindestens 15 Packungsjahre', py_fail: '✗ Weniger als 15 Packungsjahre',
        yes: 'Ja', no: 'Nein',
        info_c4: [
            'Rauchpausen innerhalb der 25 Jahre, die nicht länger als 10 Jahre waren, zählen bei der Aufsummierung der Rauchjahre mit.',
            'Wenn Sie z.\u202fB. vor 5 Jahren wieder angefangen haben zu rauchen, nachdem Sie eine 5-jährige rauchfreie Zeit hatten, zählen Sie diese 5 Jahre bitte mit.',
            'Sollten Sie nach einer Rauchpause von über 10 Jahren wieder angefangen haben zu rauchen, berücksichtigen Sie die Jahre vor der Pause bitte nicht.',
            'Sollten Sie sich unsicher sein, beraten Sie sich bitte mit Ihrer Hausärztin oder Ihrem Hausarzt.',
        ],
        info_c5: [
            'Die Rauchintensität wird medizinisch in Packungsjahren gemessen.',
            '1 Packungsjahr bedeutet 1 Schachtel, d.\u202fh. 20 Zigaretten pro Tag über ein Jahr.',
            'Mindestens 15 Packungsjahre sind Voraussetzung für die Kostenübernahme durch die GKV.',
            'Umgerechnet auf 25 Jahre Rauchhistorie sind dies im Durchschnitt 12 Zigaretten pro Tag.',
        ],
        sb_title: 'Kostenübernahme für das Screening durch die GKV derzeit nicht möglich',
        sb_back: 'Zurück', sb_restart: 'Neu starten',
        fail_ins: 'Als privat Versicherte/r haben Sie keinen Anspruch auf die GKV-Kostenübernahme für das Lungenkrebsscreening. Das Screening kann dennoch auf eigene Kosten oder über Ihren privaten Krankenversicherer möglicherweise abgerechnet werden. Bitte sprechen Sie mit Ihrer Hausärztin oder Ihrem Hausarzt.',
        fail_age: 'Die GKV übernimmt die Kosten des Screenings für Personen zwischen 50 und 75 Jahren. Das Screening kann dennoch in Absprache mit Ihrer Hausärztin oder Ihrem Hausarzt durchgeführt werden.',
        fail_smoke: 'Voraussetzung für die GKV-Kostenübernahme ist, dass Sie aktuell rauchen oder innerhalb der letzten 10 Jahre aufgehört haben. Das Screening kann dennoch in Absprache mit Ihrer Hausärztin oder Ihrem Hausarzt durchgeführt werden.',
        fail_years: 'Voraussetzung für die GKV-Kostenübernahme sind mindestens 25 Rauchjahre. Das Screening kann dennoch in Absprache mit Ihrer Hausärztin oder Ihrem Hausarzt durchgeführt werden.',
        fail_py: 'Voraussetzung für die GKV-Kostenübernahme sind mindestens 15 Packungsjahre. Das Screening kann dennoch in Absprache mit Ihrer Hausärztin oder Ihrem Hausarzt durchgeführt werden.',
        fail_lc: 'Das GKV-Programm richtet sich an Personen ohne bekannte Lungenkrebsdiagnose. Bitte wenden Sie sich direkt an Ihre Hausärztin oder Ihren Hausarzt.',
        rok_title: 'Voraussetzungen erfüllt',
        rok_1: 'Auf Basis Ihrer Eingaben erfüllen Sie die Voraussetzungen für die Kostenübernahme des Lungenscreenings durch die gesetzliche Krankenkasse.',
        rok_2: 'Wir empfehlen, dass Sie sich mit Ihrer Hausärztin oder Ihrem Hausarzt über Ihre Möglichkeiten beraten.',
        rok_3: 'Auch wenn es vielleicht mühsam erscheint, es lohnt sich. Nutzen Sie Ihre Möglichkeiten!',
        btn_website: 'Zur Website', restart: 'Neu starten',
        yr_lbl: 'Jahre', ys_lbl: 'Jahre geraucht', py_lbl: 'Packungsjahre',
    },
    en: {
        hero_title: 'Does the statutory health insurance (GKV) cover the costs of lung cancer screening for me?',
        hero_sub: 'Answer the following questions to find out.',
        back: 'Back', confirm: 'Confirm',
        badge_ok: '✓ Met', badge_stop: '✗ Not met', edit_hint: '✎ edit',
        c1_title: 'Insurance type', c2_title: 'Age',
        c3_title: 'Smoking status', c4_title: 'Smoking duration',
        c5_title: 'Smoking intensity', c6_title: 'Prior lung cancer diagnosis',
        c1_sub: 'Which type of health insurance do you have?',
        c2_sub: 'The screening program targets people between 50 and 75 years of age.',
        c3_sub: 'Choose the option that best describes you.',
        c4_sub: 'How many years have you smoked in total? (Tip: Tap ⓘ for rules on counting smoking breaks.)',
        c5_sub: 'How many cigarettes do you smoke or have you smoked per day on average? Note: Click ⓘ for explanations of smoking intensity and pack years',
        c6_sub: 'Have you been diagnosed with lung cancer?',
        ins_a: 'Statutory health insurance (GKV)', ins_b: 'Private health insurance',
        sm_a: 'I currently smoke',
        sm_b: 'Quit smoking within the last 10 years',
        sm_c: 'Quit smoking more than 10 years ago',
        sm_d: 'Never smoked',
        age_unit: 'years', age_in: '✓ Within target range (50-75 years)', age_out: '✗ Outside target range',
        ys_unit: 'years', cig_lbl: 'Cigarettes per day:', cig_unit: 'cigarettes / day',
        py_lbl_y: 'Years', py_lbl_p: 'Packs/day', py_lbl_r: 'Pack years',
        py_hint: 'e.g. 25 years x 0.6 packs/day = 15 pack years',
        py_ok: '✓ At least 15 pack years', py_fail: '✗ Fewer than 15 pack years',
        yes: 'Yes', no: 'No',
        info_c4: [
            'Smoking breaks within those 25 years that were no longer than 10 years still count towards the total.',
            'For example, if you started smoking again 5 years ago after a 5-year break, include those 5 years in your total.',
            'If you restarted smoking after a break of more than 10 years, do not count the years before that break.',
            'If you are unsure, please consult your GP for individual advice.',
        ],
        info_c5: [
            'Smoking intensity is measured medically in pack years.',
            '1 pack year means 1 pack (20 cigarettes) per day for one year.',
            'At least 15 pack years are required for GKV cost coverage.',
            'Based on a 25-year smoking history, this equals an average of 12 cigarettes per day.',
        ],
        sb_title: 'GKV cost coverage currently not applicable',
        sb_back: 'Back', sb_restart: 'Start over',
        fail_ins: 'As a privately insured person, you are not entitled to GKV cost coverage for lung cancer screening. Screening may still be possible through your private insurer or at your own expense. Please consult your GP.',
        fail_age: 'The GKV covers screening costs for people aged 50-75. Screening can still be arranged in consultation with your GP.',
        fail_smoke: 'GKV coverage requires that you currently smoke or have quit within the last 10 years. Screening can still be arranged in consultation with your GP.',
        fail_years: 'GKV coverage requires at least 25 years of smoking history. Screening can still be arranged in consultation with your GP.',
        fail_py: 'GKV coverage requires at least 15 pack years. Screening can still be arranged in consultation with your GP.',
        fail_lc: 'The GKV program is for people without a known lung cancer diagnosis. Please speak directly with your GP.',
        rok_title: 'All criteria met',
        rok_1: 'Based on your answers, you meet the requirements for GKV cost coverage of lung cancer screening.',
        rok_2: 'We recommend discussing your options with your GP.',
        rok_3: 'Even if it seems like an effort, it is worth it. Make use of your options!',
        btn_website: 'Go to website', restart: 'Start over',
        yr_lbl: 'years', ys_lbl: 'Years smoked', py_lbl: 'Pack years',
    }
};
const T = k => TX[S.lang][k];

function unlock(n) {
    console.log("unlock");
    const el = document.getElementById('c' + n);
    if (!el) { showSuccess(); return; }
    el.classList.remove('locked');
    el.classList.add('active');
    const body = el.querySelector('.crit-body');
    body.style.maxHeight = '';
    body.style.padding = '';
    setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 80);
}

function lockStep(el) {
    console.log("unlock");
    el.className = 'crit locked';
    const body = el.querySelector('.crit-body');
    body.style.maxHeight = '0'; body.style.padding = '0 1.1rem';
    const id = el.id.replace('c', '');
    const badge = document.getElementById('c' + id + '-badge');
    if (badge) badge.style.display = 'none';
    const fail = document.getElementById('c' + id + '-fail');
    if (fail) fail.style.display = 'none';
}

function markDone(n) {
    console.log("unlock");
    const el = document.getElementById('c' + n);
    const bdg = document.getElementById('c' + n + '-badge');
    el.classList.remove('active', 'stopped');
    el.classList.add('done');
    bdg.textContent = T('badge_ok');
    bdg.className = 'crit-badge badge-ok';
    bdg.style.display = '';
    const body = el.querySelector('.crit-body');
    body.style.maxHeight = '0'; body.style.padding = '0 1.1rem';
    updateDots();
}

function triggerStop(n, failKey) {
    console.log("unlock");
    stopped = true; stoppedAt = n;
    const el = document.getElementById('c' + n);
    const bdg = document.getElementById('c' + n + '-badge');
    el.classList.remove('active');
    el.classList.add('stopped');
    bdg.textContent = T('badge_stop');
    bdg.className = 'crit-badge badge-stop';
    bdg.style.display = '';
    const fi = document.getElementById('c' + n + '-fail');
    if (fi) { fi.textContent = T(failKey); fi.style.display = 'block'; }
    const body = el.querySelector('.crit-body');
    body.style.maxHeight = '0'; body.style.padding = '0 1.1rem';
    for (let i = n + 1; i <= TOTAL; i++) {
        const e = document.getElementById('c' + i);
        if (e) lockStep(e);
    }
    document.getElementById('sb-title').textContent = T('sb_title');
    document.getElementById('sb-body').textContent = T(failKey);
    document.getElementById('sb-back-lbl').textContent = T('sb_back');
    document.getElementById('sb-restart-lbl').textContent = T('sb_restart');
    const banner = document.getElementById('stopBanner');
    banner.classList.add('show');
    updateDots();
    setTimeout(() => banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 100);
}

function advanceOk(n) {
    console.log("unlock");
    markDone(n);
    if (n < TOTAL) unlock(n + 1);
    else showSuccess();
}

function reopenStep(n) {
    console.log("unlock");
    const el = document.getElementById('c' + n);
    if (!el) return;
    el.className = 'crit active';
    const body = el.querySelector('.crit-body');
    body.style.maxHeight = ''; body.style.padding = '';
    const bdg = document.getElementById('c' + n + '-badge');
    if (bdg) bdg.style.display = 'none';
    const fi = document.getElementById('c' + n + '-fail');
    if (fi) { fi.textContent = ''; fi.style.display = 'none'; }
    el.querySelectorAll('.mc-btn, .yn-btn').forEach(b => {
        b.className = b.classList.contains('yn-yes') ? 'yn-btn yn-yes' :
            b.classList.contains('yn-no') ? 'yn-btn yn-no' : 'mc-btn';
    });
    for (let i = n + 1; i <= TOTAL; i++) {
        const e = document.getElementById('c' + i);
        if (e) lockStep(e);
    }
    clearStateFrom(n);
    document.getElementById('stopBanner').classList.remove('show');
    document.getElementById('resultOk').classList.remove('show');
    stopped = false; stoppedAt = null;
    updateDots();
    setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 80);
}

function clearStateFrom(n) {
    console.log("unlock");
    if (n <= 1) S.insurance = null;
    if (n <= 2) S.age = 55;
    if (n <= 3) S.smoking = null;
    if (n <= 4) { S.yearsSmoked = 25; stV.ys = 25; }
    if (n <= 5) { S.cigsPerDay = 12; stV.cig = 12; S.packYears = 15; }
    if (n <= 6) S.lungCancer = null;
}

function goBack(fromStep) { reopenStep(fromStep - 1); }
function goBackFromStop() { if (stoppedAt) reopenStep(stoppedAt); }
function editStep(n) {
    console.log("unlock");
    const el = document.getElementById('c' + n);
    if (el && el.classList.contains('done')) reopenStep(n);
}

function pickIns(val) {
    S.insurance = val;
    const ok = val === 'gkv';
    document.querySelectorAll('#mcIns .mc-btn').forEach(b => {
        b.className = 'mc-btn' + (b.dataset.val === val ? (ok ? ' sel-ok' : ' sel-stop') : '');
    });
    setTimeout(() => ok ? advanceOk(1) : triggerStop(1, 'fail_ins'), 280);
    return false;
}

function onAge(v) {
    console.log("unlock");
    S.age = +v;
    document.getElementById('ageVal').textContent = v;
    const pct = ((v - 30) / 60 * 100).toFixed(1);
    document.getElementById('ageSlider').style.background =
        `linear-gradient(to right, var(--primary) ${pct}%, var(--border) ${pct}%)`;
    const ok = S.age >= 50 && S.age <= 75;
    const st = document.getElementById('ageStatus');
    st.textContent = ok ? T('age_in') : T('age_out');
    st.className = 'age-status ' + (ok ? 'in-range' : 'out-range');
}

function confirmAge() {
    console.log("unlock");
    if (S.age < 50 || S.age > 75) { triggerStop(2, 'fail_age'); return; }
    advanceOk(2);
}

function pickSmoke(val) {
    console.log("unlock");
    S.smoking = val;
    const ok = val === 'current' || val === 'quit_recent';
    document.querySelectorAll('#mcSmoke .mc-btn').forEach(b => {
        b.className = 'mc-btn' + (b.dataset.val === val ? (ok ? ' sel-ok' : ' sel-stop') : '');
    });
    setTimeout(() => ok ? advanceOk(3) : triggerStop(3, 'fail_smoke'), 280);
}

function stepChange(key, d) {
    console.log("stepChange");
    stV[key] = Math.max(0, Math.min(80, stV[key] + d));
    if (key === 'ys') {
        S.yearsSmoked = stV.ys;
        document.getElementById('ysVal').textContent = stV.ys;
    } else {
        S.cigsPerDay = stV.cig;
        document.getElementById('cigVal').textContent = stV.cig;
        updatePY();
    }
}

function updatePY() {
    console.log("updatePY");
    const packs = S.cigsPerDay / 20;
    S.packYears = S.yearsSmoked * packs;
    document.getElementById('pyPacks').textContent = packs.toFixed(1);
    document.getElementById('pyResult').textContent = fmtN(S.packYears);
    document.getElementById('pyYears').textContent = S.yearsSmoked;
    const st = document.getElementById('pyStatus');
    if (st) {
        const ok = S.packYears >= 15;
        st.textContent = ok ? T('py_ok') : T('py_fail');
        st.className = 'py-status ' + (ok ? 'ok' : 'fail');
        st.style.display = S.cigsPerDay > 0 ? 'inline-block' : 'none';
    }
}

function confirmYears() {
    console.log("confirmYears");
    if (S.yearsSmoked < 25) { triggerStop(4, 'fail_years'); return; }
    document.getElementById('pyYears').textContent = S.yearsSmoked;
    updatePY();
    advanceOk(4);
}

function confirmPY() {
    console.log("confirmPY");
    if (S.packYears < 15) { triggerStop(5, 'fail_py'); return; }
    advanceOk(5);
}

function pickYN(field, val) {
    console.log("pickYN");
    const n = 6;
    const ok = field === 'lc' && val === 'no';
    document.getElementById('c' + n).querySelectorAll('.yn-btn').forEach(b => {
        b.className = 'yn-btn yn-' + b.dataset.val +
            (b.dataset.val === val ? (ok ? ' sel-ok' : ' sel-stop') : '');
    });
    setTimeout(() => ok ? advanceOk(n) : triggerStop(n, 'fail_lc'), 280);
}

function showSuccess() {
    console.log("showSuccess");
    document.getElementById('rok-title').textContent = T('rok_title');
    document.getElementById('rok-stats').innerHTML =
        `<div><div class="rs-v">${S.age}</div><div class="rs-l">${T('yr_lbl')}</div></div>
     <div><div class="rs-v">${S.yearsSmoked}</div><div class="rs-l">${T('ys_lbl')}</div></div>
     <div><div class="rs-v">${fmtN(S.packYears)}</div><div class="rs-l">${T('py_lbl')}</div></div>`;
    document.getElementById('rok-msgs').innerHTML =
        ['rok_1', 'rok_2', 'rok_3'].map((k, i) =>
            `<div class="rok-msg"><span>${TX[S.lang][k]}</span></div>`
        ).join('');
    document.getElementById('btn-website-lbl').textContent = T('btn_website');
    document.getElementById('restart-ok-lbl').textContent = T('restart');
    const r = document.getElementById('resultOk');
    r.classList.add('show');
    setTimeout(() => r.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 100);
}

function updateDots() {
    console.log("updateDots");
    const c = document.getElementById('progDots');
    c.innerHTML = '';
    for (let i = 1; i <= TOTAL; i++) {
        const el = document.getElementById('c' + i);
        const d = document.createElement('div');
        d.className = 'prog-dot' +
            (el && el.classList.contains('done') ? ' done' :
                el && el.classList.contains('stopped') ? ' fail' : '');
        c.appendChild(d);
    }
}

function toggleInfo(id) {
    console.log("toggleInfo");
    const tip = document.getElementById('info-tip-' + id);
    const isOpen = tip.classList.contains('show');
    document.querySelectorAll('.info-tip').forEach(t => t.classList.remove('show'));
    if (!isOpen) {
        tip.classList.add('show');
        const btn = document.getElementById('info-btn-' + id);
        const inHead = btn.closest('.head-info');
        if (!inHead) {
            const rect = btn.getBoundingClientRect();
            tip.classList.toggle('flip', rect.top < 200);
        }
        setTimeout(() => {
            const handler = e => {
                if (!tip.contains(e.target) && e.target !== btn) {
                    tip.classList.remove('show');
                    document.removeEventListener('click', handler);
                }
            };
            document.addEventListener('click', handler);
        }, 10);
    }
}

function doRestart() {
    console.log("doRestart");
    Object.assign(S, { insurance: null, age: 55, smoking: null, yearsSmoked: 25, cigsPerDay: 12, packYears: 15, lungCancer: null });
    stV.ys = 25; stV.cig = 12;
    stopped = false; stoppedAt = null;
    for (let i = 1; i <= TOTAL; i++) {
        const el = document.getElementById('c' + i);
        if (!el) continue;
        el.className = 'crit' + (i === 1 ? ' active' : ' locked');
        const body = el.querySelector('.crit-body');
        body.style.maxHeight = ''; body.style.padding = '';
        el.querySelectorAll('.mc-btn,.yn-btn').forEach(b => {
            b.className = b.classList.contains('yn-yes') ? 'yn-btn yn-yes' :
                b.classList.contains('yn-no') ? 'yn-btn yn-no' : 'mc-btn';
        });
        const bdg = document.getElementById('c' + i + '-badge');
        if (bdg) bdg.style.display = 'none';
        const fi = document.getElementById('c' + i + '-fail');
        if (fi) { fi.style.display = 'none'; fi.textContent = ''; }
    }
    document.getElementById('ysVal').textContent = '25';
    document.getElementById('cigVal').textContent = '12';
    document.getElementById('ageSlider').value = 55;
    document.getElementById('stopBanner').classList.remove('show');
    document.getElementById('resultOk').classList.remove('show');
    onAge(55); updatePY(); updateDots();
    document.getElementById('c1').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function toggleLang() {
    console.log("toggleLang");
    S.lang = S.lang === 'de' ? 'en' : 'de';
    document.getElementById('langBtn').textContent = S.lang === 'de' ? 'EN' : 'DE';
    document.documentElement.lang = S.lang;
    applyLang();
}

function setText(id, val) { const e = document.getElementById(id); if (e) e.textContent = val; }

function applyLang() {
    console.log("applyLang");
    const L = TX[S.lang];
    setText('hero-title', L.hero_title); setText('hero-sub', L.hero_sub);
    for (let i = 1; i <= TOTAL; i++) {
        setText('c' + i + '-title', L['c' + i + '_title']);
        setText('c' + i + '-edit', L.edit_hint);
    }
    setText('c1-sub', L.c1_sub); setText('c2-sub', L.c2_sub);
    setText('c3-sub', L.c3_sub); setText('c4-sub', L.c4_sub);
    setText('c5-sub', L.c5_sub); setText('c6-sub', L.c6_sub);
    setText('ins-a', L.ins_a); setText('ins-b', L.ins_b);
    setText('sm-a', L.sm_a); setText('sm-b', L.sm_b); setText('sm-c', L.sm_c); setText('sm-d', L.sm_d);
    setText('age-unit', L.age_unit); setText('ys-unit', L.ys_unit);
    setText('cig-lbl', L.cig_lbl); setText('cig-unit', L.cig_unit);
    setText('py-lbl-y', L.py_lbl_y); setText('py-lbl-p', L.py_lbl_p); setText('py-lbl-r', L.py_lbl_r);
    setText('py-hint', L.py_hint);
    setText('yes-6', L.yes); setText('no-6', L.no);
    document.querySelectorAll('.back-lbl').forEach(e => e.textContent = L.back);
    document.querySelectorAll('.confirm-lbl').forEach(e => e.textContent = L.confirm);
    setText('sb-title', L.sb_title);
    setText('sb-back-lbl', L.sb_back); setText('sb-restart-lbl', L.sb_restart);
    const c4l = document.getElementById('info-list-c4');
    if (c4l) c4l.innerHTML = L.info_c4.map(t => `<li>${t}</li>`).join('');
    const c5l = document.getElementById('info-list-c5');
    if (c5l) c5l.innerHTML = L.info_c5.map(t => `<li>${t}</li>`).join('');
    setText('rok-title', L.rok_title);
    setText('btn-website-lbl', L.btn_website); setText('restart-ok-lbl', L.restart);
    onAge(S.age); updatePY(); updateDots();
}

function fmtN(v) { return v % 1 === 0 ? v.toFixed(0) : v.toFixed(1); }